import { css } from "@emotion/react";

import { tableGridCell, tableGridHeader, tableGridRow } from "./table-grid";

/**
 * TableGrid with custom styles for "Rated tickets per agent" tables
 */

export const header = [
  tableGridHeader,
  css`
    height: 35px;
    text-transform: uppercase;
  `,
];

export const row = [
  tableGridRow,
  css`
    min-height: 50px;
  `,
];

// Column with agent name has fluid width
export const agentCell = [
  tableGridCell,
  css`
    flex: 2;
    min-width: 0;
    padding-left: 15px;
    padding-right: 7px;
  `,
];

// Other columns should split free space on equal proportion
export const ratedTicketsCell = [
  tableGridCell,
  css`
    width: 120px;
    text-align: center;
  `,
];

// Other columns should split free space on equal proportion
export const otherCell = [
  tableGridCell,
  css`
    flex: 1;
    display: flex;
    align-items: center;
  `,
];
